import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=a2bc07cc&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=a2bc07cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bc07cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2bc07cc')) {
      api.createRecord('a2bc07cc', component.options)
    } else {
      api.reload('a2bc07cc', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=a2bc07cc&scoped=true&", function () {
      api.rerender('a2bc07cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ShnA83etwx5q/JS/comp/Voucher.vue"
export default component.exports